/**
 * Knowledge Base Module Routes Configuration
 *
 * Routes for the knowledge base module
 * Path: /app/knowledge-base/*
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load components
const KnowledgeBase = lazy(() => import('../pages/KnowledgeBase'));

/**
 * Knowledge Base routes configuration
 * These routes are mounted under /app/knowledge-base
 */
export const knowledgeBaseRoutes: RouteObject[] = [
  {
    index: true,
    element: <KnowledgeBase />
  }
];

export default knowledgeBaseRoutes;
